/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable-next-line jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'querystring';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminBannerAdd(routeProps: RouteComponentProps) {
  const history = useHistory();
  const [savingFile, setSavingFile] = useState<File>();
  const [siteUrlText, setSiteUrlText] = useState('http://www.');
  const [collegeText, setCollegeText] = useState('');
  const [bannerFlag, setBannerFlag] = useState<Number>();
  const [targetText, setTargetText] = useState('_blank');
  const option = queryString.decode(routeProps.location.search.substring(1));
  const [fileUrl, setFileUrl] = useState('');
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (option.insert !== undefined && option.insert) {
      const bannerItem: any = routeProps.location.state;
      setSiteUrlText(bannerItem.siteurl);
      setCollegeText(bannerItem.college);
      setTargetText(bannerItem.target);
    }
  }, []);

  // 등록 버튼 클릭 시
  const insertBanner = async () => {
    if (bannerFlag === undefined || bannerFlag === null) {
      dispatch(toast.error({ message: '구분을 선택해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (savingFile === undefined || savingFile === null) {
      dispatch(toast.error({ message: '배너를 업로드해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    const savedBanner = await server
      .InsertBanner({
        siteUrl: siteUrlText,
        college: collegeText,
        target: targetText,
        flag: String(bannerFlag),
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/banner-logo/banner');
        return payload;
      });

    if (savedBanner !== undefined) {
      const bannerId = savedBanner.id;
      if (savingFile !== undefined) {
        await server
          .updateBannerAttache(bannerId, { image: savingFile })
          .then(() => {
            history.push('/admin/banner-logo/banner');
          })
          .catch((error) => {
            dispatch(toast.error({ message: '첨부파일 에러' }));
            console.log('error    ', error);
            return error;
          });
      }
    }
  };

  // 배너이미지 업로드
  const attachFileDom = () => {
    return (
      <li>
        <span className="required">배너 이미지</span>
        <div className="input-file-container">
          <input
            className="input-file"
            id="file01"
            type="file"
            multiple
            onChange={(e) => {
              if (e.target !== null && e.target.files !== null && e.target.files[0] !== undefined) {
                setSavingFile(e.target.files[0]);
                const preview = e.target.files[0];
                const imageUrl = URL.createObjectURL(preview);
                setFileUrl(imageUrl);
              }
            }}
          />
          <label tabIndex={0} htmlFor="file01" className="input-file-trigger">
            파일 선택
          </label>
        </div>
        <img
          src={fileUrl}
          alt={savingFile?.name}
          onLoad={() => {
            dispatch(toast.info({ message: '이미지 업로드 완료.' }));
            window.URL.revokeObjectURL(fileUrl);
          }}
        />
        <small>※ 사이즈: 125x40 (픽셀)</small>
      </li>
    );
  };

  // 테이블 양식
  function createBannerTable() {
    return (
      <main className="images wrapper">
        <ul className="inputs">
          {attachFileDom()}
          <li>
            <span>연결 URL</span>
            <input
              id="siteUrl"
              className="full"
              type="url"
              value={siteUrlText || ''}
              onChange={(dom) => {
                setSiteUrlText(dom.target.value);
              }}
            />
          </li>
          <li>
            <span>상호명</span>
            <input
              id="college"
              type="text"
              value={collegeText || ''}
              onChange={(dom) => {
                setCollegeText(dom.target.value);
              }}
            />
            <small>※ 해당 배너의 업체명을 입력해주세요.</small>
          </li>
          <li>
            <span className="required">구분</span>
            <div className="radio">
              <input
                type="radio"
                defaultChecked={bannerFlag === 1}
                id="cooperative"
                name="flag"
                value="cooperative"
                onClick={() => setBannerFlag(1)}
              />
              <label
                htmlFor="cooperative"
                onClick={() => setBannerFlag(1)}
                style={{ display: 'flex' }}
              >
                협력사
              </label>
            </div>
            <div className="radio">
              <input
                type="radio"
                defaultChecked={bannerFlag === 2}
                id="academy"
                name="flag"
                value="academy"
                onClick={() => setBannerFlag(2)}
              />
              <label htmlFor="academy" onClick={() => setBannerFlag(2)} style={{ display: 'flex' }}>
                교육기관
              </label>
            </div>
          </li>
        </ul>
      </main>
    );
  }

  // AdminBannerAdd 리턴값
  return (
    <main className="images wrapper">
      <div className="title">
        <h1>협력사 / 교육기관 배너 등록하기</h1>
        <div className="buttons">
          {/* <button type="button">등록</button> */}
          <button type="button" onClick={insertBanner}>
            등록
          </button>
        </div>
      </div>
      <div className="content">{createBannerTable()}</div>
    </main>
  );
}
